import { Group } from '@mantine/core';
import { IAutomationSetDeviceEvidenceField } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import P3Medium from 'components/typography/P3Medium';
import P3Regular from 'components/typography/P3Regular';
import InputMention from 'pages/revisions-module/template-editor/editors/InputMention';
import { useEffect, useState } from 'react';
import { useApi } from 'api/api-context';

/**
 * The automation preview for set-device-evidence-field automation.
 */
export default function SetDeviceEvidenceFieldAutomationPreview({ data }: { data: IAutomationSetDeviceEvidenceField }) {
  const { getAction } = useApi();
  const [evidenceFieldName, setEvidenceFieldName] = useState<string>('Načítavam...');

  useEffect(() => {
    const fetchEvidenceFields = getAction('DeviceListAllEvidenceFields');

    fetchEvidenceFields().then((fields) => {
      const { fieldName = 'Neznáme pole' } =
        fields.find((field) => field.evidenceFieldId === Number(data.evidenceFieldId)) ?? {};

      setEvidenceFieldName(fieldName);
    });
  }, [data.evidenceFieldId]);

  return (
    <>
      <Group spacing={4}>
        <P3Medium>Hodnota:</P3Medium>
        <P3Regular>
          <InputMention prefix="Z poľa" name={data.inputName} />
        </P3Regular>
      </Group>

      <span>&#x7c;</span>

      <Group spacing={4}>
        <P3Medium>Evidenčné pole:</P3Medium>
        <P3Regular>{`(#${data.evidenceFieldId}) ${evidenceFieldName}`}</P3Regular>
      </Group>
    </>
  );
}
